import ScannerErrorLog from '@/models/ScannerErrorLog/ScannerErrorLog';

export default class ScannerErrorLogFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.logDateFrom = '';
		this.logDateTo = '';
		this.controlCardId  = '';
		this.controlCardControlCardNumber = '';
		this.partId  = '';
		this.partPartNumber = '';
		this.customerId  = '';
		this.customerCode = '';
		this.caseQty = '';
		this.transactionType = '';
		this.transactionId = '';
		this.userId  = '';
		this.userFirstName = '';
		this.errMessageMultiple = '';
		this.inputType = '';
		this.inputTypeId = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			logDateFrom : '0',
			logDateTo : '0',
			controlCardId : '0',
			controlCardControlCardNumber : '0',
			partId : '0',
			partPartNumber : '0',
			customerId : '0',
			customerCode : '0',
			caseQty : '0',
			transactionType : '0',
			transactionId : '0',
			userId : '0',
			userFirstName : '0',
			errMessageMultiple : '0',
			inputType : '0',
			inputTypeId : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}